export default class Subtitle {
  constructor(container) {
    this.container = container;
    this.container.style.position = "relative";

    this.subtitleEl = document.createElement("div");
    Object.assign(this.subtitleEl.style, {
      position: "fixed",
      bottom: "30px",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "rgba(0,0,0,0.7)",
      color: "white",
      padding: "10px 20px",
      borderRadius: "10px",
      fontSize: "24px",
      fontFamily: "sans-serif",
      textAlign: "center",
      textShadow: "2px 2px 4px black",
      maxWidth: "80%",
      zIndex: "9999",
      pointerEvents: "none",
      opacity: "0",
      transition: "opacity 0.3s ease",
      whiteSpace: "pre-wrap"
    });

    this.container.appendChild(this.subtitleEl);

    this._thinkingInterval = null;
    this._savedText = "";   // Stores text before thinking starts
  }

  show(text) {
    this.clearThinking();
    this._savedText = text;
    this.subtitleEl.textContent = text;
    this.subtitleEl.style.opacity = "1";
  }

  addPartial(text) {
    // If thinking is active, restore saved text first
    if (this._thinkingInterval) {
      this.clearThinking();
      this.subtitleEl.textContent = this._savedText;
    }

    // Append new partial text
    if (this.subtitleEl.textContent) {
      this.subtitleEl.textContent += " " + text;
    } else {
      this.subtitleEl.textContent = text;
    }

    // Save the new full text state
    this._savedText = this.subtitleEl.textContent;
    this.subtitleEl.style.opacity = "1";
  }

  thinking(baseText = "Thinking") {
    // Save existing text BEFORE starting animation
    this._savedText = this.subtitleEl.textContent || "";

    this.clearThinking();
    let dots = 0;

    this.subtitleEl.style.opacity = "1";
    this._thinkingInterval = setInterval(() => {
      dots = (dots + 1) % 4;
      this.subtitleEl.textContent = baseText + ".".repeat(dots);
    }, 500);
  }

  final(text) {
    // Save final text and stop thinking animation
    this.clearThinking();
    this._savedText = text;
    let dots = 0;

    this.subtitleEl.textContent = text;
    this.subtitleEl.style.opacity = "1";

    this._thinkingInterval = setInterval(() => {
      dots = (dots + 1) % 4;
      this.subtitleEl.textContent = text + ".".repeat(dots);
    }, 500);
  }

  clear() {
    this.clearThinking();
    this.subtitleEl.style.opacity = "0";
    this.subtitleEl.textContent = "";
    this._savedText = "";
  }

  clearThinking() {
    if (this._thinkingInterval) {
      clearInterval(this._thinkingInterval);
      this._thinkingInterval = null;
    }
  }
}
